import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAllBySourceID({ commit }, params) {
      commit('setListLoading', true);
      let list = await api.get("solutions/sources/bySourceID", { params: params });
      commit('setList', list.data);
      commit('setListLoading', false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutionsSources", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySourceID", payload.sources_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("solutionsSources", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySourceID", payload.sources_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
}
